{
  "name": "prior-auth-dtr",
  "version": "2026.8.1-2626362396.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "dev": "ng serve --configuration local",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:single": "ng test --watch=false",
    "test:coverage": "ng test --watch=false --coverage",
    "test:mutation": "npx stryker run",
    "test:mutation:fast": "npx stryker run --incremental",
    "test:mutation:changed": "node scripts/mutation-changed.mjs",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "validate:playwright": "node scripts/validate-playwright-version.mjs",
    "update-playwright": "npm install -D @playwright/test@latest && npx playwright install chromium",
    "lint": "ng lint",
    "lint:report": "ESLINT_CODE_QUALITY_REPORT=gl-code-quality.json eslint \"src/**/*.ts\" \"src/**/*.html\" -f gitlab",
    "license-check": "npx license-checker --summary  --direct --production  > license.txt",
    "audit": "node node_modules/better-npm-audit audit -p -l high"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.17",
    "@angular/build": "^21.2.16",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/platform-browser": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@fortawesome/fontawesome-free": "^7.2.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ngrx/effects": "^21.1.0",
    "@ngrx/operators": "^21.1.0",
    "@ngrx/store": "^21.1.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@popperjs/core": "^2.11.6",
    "@simpatico.ai/form-renderer": "^1.0.108",
    "@simpatico.ai/js-crd-client": "^2.1.1",
    "@simpatico.ai/lib-marshaler": "^1.0.32",
    "@simpatico.ai/lib-pas-request": "^1.0.53",
    "@smile-cdr/fhirts": "^2.2.8",
    "bootstrap": "^5.3.6",
    "dayjs": "^1.11.21",
    "fhirclient": "^2.5.4",
    "lodash": "^4.17.21",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.2"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.5.2",
    "@analogjs/vitest-angular": "^2.5.2",
    "@angular-devkit/build-angular": "^21.2.16",
    "@angular-eslint/builder": "^21.3.1",
    "@angular/cli": "^21.2.16",
    "@angular/compiler-cli": "^21.2.17",
    "@angular/localize": "^21.2.17",
    "@eslint/js": "^10.0.1",
    "@ngx-env/builder": "^21.0.1",
    "@playwright/test": "^1.60.0",
    "@stryker-mutator/core": "^9.6.1",
    "@stryker-mutator/vitest-runner": "^9.6.1",
    "@types/lodash": "^4.17.14",
    "@vitest/coverage-v8": "^4.1.7",
    "angular-eslint": "^21.4.0",
    "better-npm-audit": "^3.11.0",
    "eslint": "^10.4.0",
    "eslint-formatter-gitlab": "^7.1.0",
    "jsdom": "^29.1.1",
    "license-checker": "^25.0.1",
    "minimatch": "^10.2.5",
    "prettier": "^3.8.4",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.60.0",
    "vitest": "^4.1.7"
  },
  "overrides": {
    "@xmldom/xmldom": "^0.9.10",
    "piscina": "^5.2.0",
    "undici": "^7.28.0",
    "vite": "^7.3.5"
  }
}
